/**
 * Copy to Clipboard V4 Component
 * Displays an ID in a styled code block with a copy button
 * Uses manage slice for toast notifications
 */

import { IconButton } from '@mui/material'
import { ContentCopy as CopyIcon } from '@mui/icons-material'
import { useAppDispatch } from 'src/store/hooks'
import {
  successMessageChanged,
  errorMessageChanged,
} from 'src/v3/manage/manage.slice'

interface CopyToClipboardV4Props {
  value: string
  label: string
}

export default function CopyToClipboardV4({
  value,
  label,
}: CopyToClipboardV4Props) {
  let dispatch = useAppDispatch()

  let handleCopy = () => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        dispatch(successMessageChanged(`${label} copied to clipboard!`))
      })
      .catch(() => {
        dispatch(errorMessageChanged('Failed to copy to clipboard'))
      })
  }

  return (
    <code className="inline-flex items-center justify-between gap-4 p-2 bg-gray-800 rounded-lg">
      <span className="text-xs">{value}</span>
      <IconButton
        size="small"
        color="primary"
        onClick={handleCopy}
        aria-label={`Copy ${label}`}
      >
        <CopyIcon fontSize="small" />
      </IconButton>
    </code>
  )
}
